import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { selectManagers } from './my-contacts.selectors';
import { LoadManagersAction } from './my-contacts.actions';
import { selectAuthUser } from '../../auth/auth.selectors';
import { Manager } from '../../../global/interfaces';
import { User } from '../../administration/user/user.models';
import { CONFIG } from '../../../../config';
import { isNullOrUndefined } from 'util';
import { map, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { selectCountrySelected } from '../../../shared/layout/main.selectors';

@Component({
  standalone: false,
  selector: 'dsp-my-contacts',
  templateUrl: 'my-contacts.component.html',
  styleUrls: ['my-contacts.component.scss']
})
export class MyContactsComponent implements OnInit, OnDestroy {
  public user$: Observable<User | undefined>;
  public managers$: Observable<Manager[]>;
  public url: string;
  public loading: any[];

  private readonly subscription: Subscription = new Subscription();
  public profileImageDataUrl$: Observable<any[]> = new Observable<any[]>();

  public constructor(
    private readonly store: Store<AppState>,
    private readonly httpClient: HttpClient,
    private readonly domSanitizer: DomSanitizer

  ) {
    this.user$ = this.store.pipe(select(selectAuthUser));
    this.managers$ = this.store.pipe(select(selectManagers));
  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeConsultantLoad());
    this.subscription.add(this.getImageData());

  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private subscribeConsultantLoad(): Subscription {
    // return combineLatest(
    //   this.user$,
    //   this.store.pipe(select(selectCountrySelected))
    // ).pipe(
    return combineLatest([
      this.user$,
      this.store.pipe(select(selectCountrySelected))
    ]).pipe(
      take(1)
    ).subscribe(([user, country]) => {
      if (user) {
        this.store.dispatch(new LoadManagersAction({ country }));
      }
    });

  }

  private getImageData(): Subscription {
    this.url = `${CONFIG.API_URL}/users/getProfileImage/`;
    this.loading = [];
    return this.store.pipe(select(selectManagers)).subscribe(managers => {
      if (!isNullOrUndefined(managers)) {
        // managers.map(manager => {
        managers.forEach(manager => {
          if (!isNullOrUndefined(manager) && !isNullOrUndefined(manager.profileImageId)) {
            this.loading[manager.profileImageId] = true;
            const profileImageUrl = `${this.url}${manager.profileImageId}`;
            this.profileImageDataUrl$[manager.profileImageId] = this.loadImage(profileImageUrl);
          }
        });
      }
    });
  }

  private loadImage(url: any): Observable<any> {
    if (!isNullOrUndefined(url)) {
      return this.httpClient
        // load the image as a blob
        .get(url, { responseType: 'blob', withCredentials: true })
        // create an object url of that blob that we can use in the src attribute
        .pipe(map(e => this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(e))));
    } else {
      return new Observable<any>(null);
    }
  }

  onLoad(id) {
    this.loading[id] = false;
  }

  onLoadError(id) {
    this.loading[id] = true;
  }
}
